import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';

import ProjectLearningsTabQuery, {
	type ProjectLearningsTabQuery as ProjectLearningsTabQueryType,
} from '../components/ProjectLearningsTab/__generated__/ProjectLearningsTabQuery.graphql';
import { LEARNINGS_SORT, TAGS_COUNT } from '../components/ProjectLearningsTab/constants';

export const projectLearningsTabResource: RouteResource<
	PreloadedQuery<ProjectLearningsTabQueryType, Record<string, unknown>>
> = createRelayResource<ProjectLearningsTabQueryType>({
	getQuery: (routerContext) => {
		return {
			query: ProjectLearningsTabQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
				learningsSort: LEARNINGS_SORT,
				tagCount: TAGS_COUNT,
				type: 'LEARNING',
			},
		};
	},
});

export const projectRisksTabResource: RouteResource<
	PreloadedQuery<ProjectLearningsTabQueryType, Record<string, unknown>>
> = createRelayResource<ProjectLearningsTabQueryType>({
	getQuery: (routerContext) => {
		return {
			query: ProjectLearningsTabQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
				learningsSort: LEARNINGS_SORT,
				tagCount: TAGS_COUNT,
				type: 'RISK',
			},
		};
	},
});

export const projectDecisionsTabResource: RouteResource<
	PreloadedQuery<ProjectLearningsTabQueryType, Record<string, unknown>>
> = createRelayResource<ProjectLearningsTabQueryType>({
	getQuery: (routerContext) => {
		return {
			query: ProjectLearningsTabQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
				learningsSort: LEARNINGS_SORT,
				tagCount: TAGS_COUNT,
				type: 'DECISION',
			},
		};
	},
});
